import { render } from "./TablePagination.vue?vue&type=template&id=5d638fae&ts=true"
import script from "./TablePagination.vue?vue&type=script&lang=ts"
export * from "./TablePagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/TablePagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d638fae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d638fae', __exports__)) {
    api.reload('5d638fae', __exports__)
  }
  
  module.hot.accept("./TablePagination.vue?vue&type=template&id=5d638fae&ts=true", () => {
    api.rerender('5d638fae', render)
  })

}


export default __exports__